import config from '@/config';
import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { findTaskById, updateTask } from '@/shared/utils/infiniteDataHelper';
import { TaskQueryKey } from './queryKey';
const applyExecutionDate = (oldData, newData) => {
    if (!newData)
        return oldData;
    const merged = Object.assign(Object.assign({}, oldData), { executionDate: newData.executionDate });
    const oldMain = oldData;
    const newMain = newData;
    if (!(oldMain === null || oldMain === void 0 ? void 0 : oldMain.children) || !(newMain === null || newMain === void 0 ? void 0 : newMain.children))
        return merged;
    merged.children = oldMain.children.map(c => {
        const updatedChild = newMain.children.find(y => y.id === c.id);
        if (!updatedChild)
            return c;
        return Object.assign(Object.assign({}, c), { executionDate: updatedChild.executionDate });
    });
    return merged;
};
export const useUpdateTaskExecutionDate = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading, error } = useMutation(values => {
        var _a, _b;
        const formatted = (_b = (_a = values.executionDate) === null || _a === void 0 ? void 0 : _a.format('YYYY-MM-DD')) !== null && _b !== void 0 ? _b : '';
        return api.base
            .put(`${config.appUrls.tasks}/api/plannedTasks/ExecutionDate/${values.id}/${formatted}`)
            .then(res => res.data);
    }, {
        onMutate: async (taskToUpdate) => {
            await queryClient.cancelQueries({ queryKey: [TaskQueryKey.PlannedTasks] });
            const currentData = queryClient.getQueryData([TaskQueryKey.PlannedTasks]);
            const result = findTaskById(currentData, taskToUpdate.id);
            if (result) {
                queryClient.setQueryData([TaskQueryKey.PlannedTasks], oldData => oldData &&
                    updateTask(oldData, taskToUpdate.id, x => (Object.assign(Object.assign({}, x), { executionDate: taskToUpdate.executionDate }))));
            }
            return { previousTask: result === null || result === void 0 ? void 0 : result.task };
        },
        onSuccess: data => {
            queryClient.setQueryData([TaskQueryKey.PlannedTasks], oldData => oldData && updateTask(oldData, data.id, x => applyExecutionDate(x, data)));
        },
        onError: (e, taskToUpdate, context) => {
            queryClient.setQueryData([TaskQueryKey.PlannedTasks], oldData => oldData &&
                updateTask(oldData, taskToUpdate.id, x => applyExecutionDate(x, context === null || context === void 0 ? void 0 : context.previousTask)));
            handleHttpError(intl)(e);
        },
    });
    return {
        updateTaskExecutionDate: mutateAsync,
        isLoading,
        error,
    };
};
